var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-template',{attrs:{"data":_vm.data,"title":"Изображение","possible-next":_vm.possibleNext,"is-last":_vm.isLast}},[_c('v-img',{attrs:{"src":_vm.data.content,"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }